// eslint-disable-next-line import/prefer-default-export
import api from "@/api/api";

export const authActions = {
    async login(context, { email, password }) {
        try {
            const res = await api.login(email, password);
    
            context.commit('AUTHENTICATED', res.data);
    
            api.setToken(`${res.data.token_type} ${res.data.access_token}`);
    
            const expiresAt = Date.now() + res.data.expires_in * 1000;
            localStorage.setItem('expires_at', expiresAt);
    
            await context.dispatch('getLangCode', null, { root: true });
            await context.dispatch('getConstants', null, { root: true });
    
            location.assign('/');
    
        } catch (err) {
            if (err.response) {
                context.commit('SET_LOGIN_ERROR', err.response.data.errorCode);
            }
        }
    },

    logout(context) {
        // Clear token and expiry time on logout
        localStorage.removeItem('auth_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem("selectedIds");
        context.commit("treeSelectedSitesStore/SET_TREE_SELECTED_SITES_FLEET", []);
        context.commit('LOGOUT');
        context.commit('CLEAR_PARC_DATES');

        // Optionally, redirect to the login page
        location.assign('/login');
    },

    checkToken(context) {
        const now = Date.now();
        const expiresAt = parseInt(localStorage.getItem('expires_at'));
        
        if (now > expiresAt) {
            context.dispatch('logout'); // Token expired, logout the user
        }
    }
};
